export default function DocumentIcon({ className }: { className?: string }) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} w-8 h-8`}
        >
            <path
                d="M25.9287 21.7144H19.9287V27.7144L25.9287 21.7144Z"
                fill="currentFill"
            />
            <path
                d="M25.7141 22.1328L25.7141 3.67822L5.71411 3.67822L5.71411 27.6782L20.0474 27.6782L25.7141 22.1328Z"
                stroke="currentFill"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M21.7145 16L10.2859 16"
                stroke="currentFill"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M21.7145 10.2859L10.2859 10.2859"
                stroke="currentFill"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
        </svg>
    );
}
